import React from 'react';

import FiltersCountProvider from 'context/FiltersCountContext';
import GlobalDialogProvider from 'context/GlobalDialogContext';
import TourProvider from 'tour/TourProvider';

type Props = { children: React.ReactNode };

const PrivateRouteProviders: React.FC<Props> = ({ children }) => (
  <FiltersCountProvider>
    <GlobalDialogProvider>
      <TourProvider>{children}</TourProvider>
    </GlobalDialogProvider>
  </FiltersCountProvider>
);

export default PrivateRouteProviders;
